// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__U6-tG","currentPage":"TopPanel_currentPage__oGWVW"};